import React, { useState, useEffect } from 'react'
import MaterialTable from 'material-table'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  TextField,
} from '@material-ui/core'
import { Delete } from '@material-ui/icons'

const RutaVentasContainer = () => {
  const [ventas, setVentas] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [openAddDialog, setOpenAddDialog] = useState(false)
  const [newVenta, setNewVenta] = useState({
    vendedor: '',
    id_producto: '',
    fecha: '',
  })

  // Simulated data - replace with actual API call
  const getVentasData = async () => {
    setIsLoading(true)
    // Simulated API response
    const response = {
      ventas: [
        {
          cc: '100942301',
          vendedor: 'Felipe Auteco',
          id_producto: 'c5aad7b21f98d',
          repuesto: 'Llanta',
          categoria: 'cat 1',
          sub_categoria: 'scat1',
          punto_venta: 'Bogota DC',
          fecha: '4 oct 2024 - 11:00am',
          recompensa: '300.000'
        },
        {
          cc: '100942301',
          vendedor: 'Santiago Auteco',
          id_producto: 'h2aad7b21f98d',
          repuesto: 'Carcasa',
          categoria: 'cat 2',
          sub_categoria: 'scat2',
          punto_venta: 'Bogota DC',
          fecha: '5 oct 2024 - 12:00pm',
          recompensa: '80.000'
        },
        {
          cc: '100942301',
          vendedor: 'Carlos Auteco',
          id_producto: 'n1gad7b21f98d',
          repuesto: 'Motor',
          categoria: 'cat 3',
          sub_categoria: 'scat3',
          punto_venta: 'Bogota DC',
          fecha: '5 oct 2024 - 3:00pm',
          recompensa: '2.000.000'
        },
        {
          cc: '100942301',
          vendedor: 'Pedro Auteco',
          id_producto: 'a9bbd7b21f98d',
          repuesto: 'Frenos',
          categoria: 'cat 4',
          sub_categoria: 'scat4',
          punto_venta: 'Bogota DC',
          fecha: '6 oct 2024 - 9:00am',
          recompensa: '320.000'
        }
      ]
    }
    
    setVentas(response.ventas)
    setIsLoading(false)
  }

  useEffect(() => {
    getVentasData()
  }, [])

  const handleDelete = (rowData) => {
    const updatedVentas = ventas.filter(venta => 
      venta.id_producto !== rowData.id_producto
    )
    setVentas(updatedVentas)
  }

  const handleAddVenta = () => {
    // Add validation here
    const newVentaData = {
      ...newVenta,
      cc: '100942301', // This would come from actual data
      repuesto: 'Pending',
      categoria: 'Pending',
      sub_categoria: 'Pending',
      punto_venta: 'Bogota DC',
      recompensa: '0'
    }
    setVentas([...ventas, newVentaData])
    setOpenAddDialog(false)
    setNewVenta({
      vendedor: '',
      id_producto: '',
      fecha: ''
    })
  }

  const AddVentaDialog = () => (
    <Dialog
      open={openAddDialog}
      onClose={() => setOpenAddDialog(false)}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: '8px',
          padding: '16px'
        }
      }}
    >
      <DialogTitle style={{ textAlign: 'center', paddingBottom: '24px' }}>
        Agregar Venta
      </DialogTitle>
      <DialogContent>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
          <TextField
            fullWidth
            label="Vendedor"
            value={newVenta.vendedor}
            onChange={(e) => setNewVenta({ ...newVenta, vendedor: e.target.value })}
            variant="outlined"
          />
          <TextField
            fullWidth
            label="Id Producto"
            value={newVenta.id_producto}
            onChange={(e) => setNewVenta({ ...newVenta, id_producto: e.target.value })}
            variant="outlined"
          />
          <TextField
            fullWidth
            label="Fecha"
            type="datetime-local"
            value={newVenta.fecha}
            onChange={(e) => setNewVenta({ ...newVenta, fecha: e.target.value })}
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </div>
      </DialogContent>
      <DialogActions style={{ padding: '24px', justifyContent: 'center' }}>
        <Button
          onClick={handleAddVenta}
          variant="contained"
          color="primary"
          style={{
            width: '100%',
            borderRadius: '4px',
            textTransform: 'none',
            padding: '10px'
          }}
        >
          Agregar
        </Button>
      </DialogActions>
    </Dialog>
  )

  return (
    <div className="ventas-container">
      <div className="header-info">
        <Typography variant="h5">
          Historial Ventas
        </Typography>
      </div>

      <div className={`table-container ${isLoading ? 'loading' : ''}`}>
        <div className="actions-header" style={{ display: 'flex', justifyContent: 'flex-end', padding: '16px' }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setOpenAddDialog(true)}
          >
            Agregar
          </Button>
        </div>

        <MaterialTable
          title=""
          options={{
            pageSize: 10,
            pageSizeOptions: [10, 20, 50],
            headerStyle: {
              backgroundColor: '#F6F6F6',
              color: '#161615',
              fontSize: '14px',
              fontWeight: 700,
            },
            actionsColumnIndex: -1,
            search: true,
          }}
          columns={[
            { title: 'CC', field: 'cc' },
            { title: 'Vendedor', field: 'vendedor' },
            { title: 'Id Producto', field: 'id_producto' },
            { title: 'Repuesto', field: 'repuesto' },
            { title: 'Categoria', field: 'categoria' },
            { title: 'Sub Categoria', field: 'sub_categoria' },
            { title: 'Punto de Venta', field: 'punto_venta' },
            { title: 'Fecha', field: 'fecha' },
            { title: 'Recompensa', field: 'recompensa' },
            {
              title: 'Eliminar',
              render: (rowData) => (
                <IconButton onClick={() => handleDelete(rowData)}>
                  <Delete style={{ color: '#f44336' }} />
                </IconButton>
              ),
              width: 90
            }
          ]}
          data={ventas}
        />
      </div>

      <AddVentaDialog />
    </div>
  )
}

export default RutaVentasContainer